import React from "react";
import PropTypes from "prop-types";
import "./skeleton.css";

function Skeleton({
  variant = "bar",
  height,
  width,
  radius,
  animation = "shimmer",
  className = "",
  style = {},
  ...rest
}) {
  const variantClass =
    {
      bar: "",
      text: "app-skeleton--text",
      circular: "app-skeleton--circular",
      avatar: "app-skeleton--circular",
      pill: "app-skeleton--pill",
      rounded: "app-skeleton--rounded",
      card: "app-skeleton--card",
    }[variant] || "";

  const animClass =
    animation === "pulse"
      ? "app-skeleton--pulse"
      : animation === false
      ? "app-skeleton--static"
      : "";

  const inlineStyle = {
    ...(height !== undefined ? { height } : {}),
    ...(width !== undefined ? { width } : {}),
    ...(radius !== undefined ? { borderRadius: radius } : {}),
    ...style,
  };

  return (
    <span
      {...rest}
      className={`app-skeleton ${variantClass} ${animClass} ${className}`.trim()}
      style={inlineStyle}
      aria-hidden="true"
    />
  );
}

Skeleton.defaultProps = {
  variant: "bar",
  height: undefined,
  width: undefined,
  radius: undefined,
  animation: "shimmer",
  className: "",
  style: {},
};

Skeleton.propTypes = {
  variant: PropTypes.oneOf([
    "bar",
    "text",
    "circular",
    "avatar",
    "pill",
    "rounded",
    "card",
  ]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  radius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  animation: PropTypes.oneOfType([
    PropTypes.oneOf(["shimmer", "pulse"]),
    PropTypes.bool,
  ]),
  className: PropTypes.string,
  style: PropTypes.object,
};

export default Skeleton;
